import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: "#34A693",
        secondary: colors.teal.darken1,
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        primaryDk1: colors.teal.darken1,
        greenDivider: colors.teal.darken1,
        greenBg: colors.teal.lighten5,
        greenButtonTitle: colors.teal.accent4,
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});
